import { firestore } from 'firebase/app';
import {
  DreamMapper,
  FirestoreDream,
  DreamTimeframe,
  Importance,
  ImageUtil, SparkelloImage, ImageResource, SparkelloImageMapper,
} from 'sparkello-core';
import { WebDream, WebSpark } from '@/web/model';

import DocumentSnapshot = firestore.DocumentSnapshot;
import FieldValue = firestore.FieldValue;

export class WebDreamMapper implements DreamMapper<DocumentSnapshot, FieldValue> {
  public mapToLocalDream(doc: DocumentSnapshot): WebDream {
    const dream = new WebDream(doc.id, doc.data()?.displayName);
    dream.image = SparkelloImageMapper.mapToSparkelloImage(doc.data()?.image, doc.data()?.imageUri);
    dream.description = doc.data()?.description;
    dream.why = doc.data()?.why;
    dream.when = new DreamTimeframe(doc.data()?.when);
    dream.importance = new Importance(doc.data()?.importance);
    dream.dateCreated = doc.data()?.dateCreated?.toDate();
    dream.lastUpdated = doc.data()?.lastUpdated?.toDate();

    if (doc.data()?.sparkId) {
      dream.sparkId = doc.data()?.sparkId;
    }

    return dream;
  }

  public mapToFirestoreDream(dream: WebDream): FirestoreDream<FieldValue> {
    const firestoreDream: FirestoreDream<FieldValue> = {
      displayName: dream.displayName,
      description: dream?.description || '',
      why: dream?.why || '',
      when: dream?.when?.get() || '',
      importance: dream?.importance?.get() || 0,
      image: SparkelloImageMapper.mapToFirestoreImage(dream.image),
      dateCreated: dream?.dateCreated ? dream?.dateCreated : firestore.FieldValue.serverTimestamp(),
      lastUpdated: firestore.FieldValue.serverTimestamp(),
    };

    if (dream?.sparkId) {
      firestoreDream.sparkId = dream.sparkId;
    }

    return { ...firestoreDream } as FirestoreDream<FieldValue>;
  }

  public mapSparkToDream(spark: WebSpark): WebDream {
    const dream: WebDream = new WebDream('', spark.displayName);
    dream.sparkId = spark.id;
    dream.description = spark.description;
    dream.image = spark.image;

    return dream;
  }
}



